.modal {
  display: flex;
  width: 100%;
  max-height: calc(100vh - (2 * var(--pgm-sys-spacing-6)));
  flex-direction: column;
  overflow: hidden;
  border: 1px solid var(--pgm-sys-color-outline-variant);
  border-radius: var(--pgm-sys-spacing-4);
  background-color: var(--pgm-sys-color-surface);
  color: var(--pgm-sys-color-on-surface);
  box-shadow: var(--pgm-sys-elevation-level3);
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--pgm-sys-spacing-4);
  padding: var(--pgm-sys-spacing-6);
}

.title {
  margin: 0;
  color: var(--pgm-sys-color-on-surface);
}

.feedback {
  display: flex;
  align-items: center;
  gap: var(--pgm-sys-spacing-2);
  margin-inline: var(--pgm-sys-spacing-6);
  padding: var(--pgm-sys-spacing-3);
  border-radius: var(--pgm-sys-spacing-2);
  background-color: var(--pgm-sys-color-error-container);
  color: var(--pgm-sys-color-on-error-container);
}

.content {
  display: flex;
  align-items: center;
  flex-direction: column;
  overflow-y: auto;
  padding: 0 var(--pgm-sys-spacing-6) var(--pgm-sys-spacing-6);
}

.userIcon {
  color: var(--pgm-sys-color-primary);
  font-size: 80px;
  font-variation-settings: "FILL" 1;
  line-height: 1;
}

.initialMessage {
  max-width: 520px;
  margin: var(--pgm-sys-spacing-4) 0 var(--pgm-sys-spacing-6);
  color: var(--pgm-sys-color-on-surface-variant);
  text-align: center;
}

.form {
  display: flex;
  width: min(100%, 520px);
  flex-direction: column;
  gap: var(--pgm-sys-spacing-4);
}

.documents {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-3);
}

.documentRow {
  display: flex;
  align-items: center;
  gap: var(--pgm-sys-spacing-2);
}

.documentRow > :first-child {
  min-width: 0;
  flex: 1;
}

.actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--pgm-sys-spacing-4);
  margin-top: var(--pgm-sys-spacing-2);
}

.loadingIcon {
  animation: spin 800ms linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@media (max-width: 599px) {
  .modal {
    max-height: calc(100vh - (2 * var(--pgm-sys-spacing-2)));
  }

  .header,
  .content {
    padding-inline: var(--pgm-sys-spacing-4);
  }

  .feedback {
    margin-inline: var(--pgm-sys-spacing-4);
  }

  .actions {
    align-items: stretch;
    flex-direction: column;
  }
}
